import { useState, useEffect } from "react";
import { Layout, Row, Col, Form, Input, Button, Checkbox } from "antd";
import {
  FullHeightRow,
  AuthLeftContainer,
  HaberForm,
  AuthTitleBlock,
} from "../styledElements";
import AuthRightContainer from "../../Components/AuthRightBox/authRightContainer";
import AlertContainer from "../../Components/AlertBoxes/alertBox";
import Logo from "../../Assets/Images/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { authenticateUser } from "../../Services/loginServices";
import { setSessionId, setCsrfToken, setToken } from "../../Services/localStorageServices";
import { useDispatch } from "react-redux";
import { ActionTypes } from "../../Constants/ActionTypes";
import store from "../../ReduxStore/store";
import alertRed from "../../Assets/Icons/alertRed.svg";
import { getUserProfile, getCsrfToken } from "../../Services/loginServices";
import { getCompanyDetails } from "../../Services/companyServices";
import { useCookies } from 'react-cookie';
import { getMachineGradeSelectForConfig } from "../../Services/settingsServices";
import { initializeWebSocket } from "../../Services/webSocketService";

const validateMessages = {
  required: "This field is required!",
  types: {
    email: "Not a valid email format!",
  },
};

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isChecked, setChecked] = useState(true);
  const [cookies, setCookie] = useCookies([]);
  const [showLoginPage, setLoginPage] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (cookies?.rememberMe === 'true') {
      getCsrfToken().then(token => {
        setCsrfToken(token.data.csrf_token);
        if (token.data.csrf_token) {
          redirectToLandingPage();
        }
      }).catch(err => {
        console.log("Error while fetching csrf token", err)
      })
    } else {
      setLoginPage(true);
      // getCsrfToken().then(token => {
      //   console.log("Csrf Token", token)
      //   setCsrfToken(token.data.csrf_token);
      // }).catch(err => {
      //   console.log("Error while fetching csrf token", err)
      // })
    }
  }, [])

  const rememberMeHandler = (event) => {
    setChecked(event.target.checked);
  };

  const redirectToLandingPage = async () => {
    const resp = await getMachineGradeSelectForConfig();
    if (!resp.error) {
      localStorage.setItem("setting-data", JSON.stringify(resp?.data?.data));
    }
    const userProfile = await getUserProfile();
    localStorage.setItem("user-details", JSON.stringify(userProfile));
    getCompanyDetails()
      .then((response) => {
        localStorage.setItem("company", JSON.stringify(response.data))
      })
      .catch((error) => {
        console.log("Error in getting company details:", error.response.data);
      });
    store.dispatch({
      type: ActionTypes.loginActions.SET_USER_PROFILE,
      data: {
        email: userProfile?.email,
      },
    });
    // Initialize WebSocket connection for real-time notifications
    initializeWebSocket();
    navigate("/landing-page", { replace: true });
  }

  const onLoginClick = async () => {
    if (email && email.length && password && password.length) {
      try {
        const authenticateResponse = await authenticateUser(email, password);

        let loginDateTime = new Date();
        setCookie('accessToken', authenticateResponse?.data.data.access_token, { path: '/', maxAge: 31536000 });
        setCookie('rememberMe', isChecked, { path: '/', maxAge: 31536000 });
        setCookie('loginDateTime', loginDateTime, { path: '/', maxAge: 31536000 });

        if (!authenticateResponse.data.error) {
          const resp = await getMachineGradeSelectForConfig();
          if (!resp.error) {
            localStorage.setItem("setting-data", JSON.stringify(resp?.data?.data));
          }

          const userProfile = await getUserProfile();
          localStorage.setItem("user-details", JSON.stringify(userProfile));
          getCompanyDetails()
            .then((response) => {
              localStorage.setItem("company", JSON.stringify(response.data))
            })
            .catch((error) => {
              console.log("Error in getting company details:", error.response.data);
            });
          store.dispatch({
            type: ActionTypes.loginActions.SET_USER_PROFILE,
            data: {
              email: email,
            },
          });
          // Initialize WebSocket connection for real-time notifications
          initializeWebSocket();
          navigate("/landing-page", { replace: true });
        }
      } catch (error) {
        console.log("Error response from login", error.response);
        //To be done:If a user login's for the first time using his temporary password,he should be redirected to create-account page.
        if (error.response?.data?.data == null) {
          setErrorMessage(error.response?.data?.msg);
          navigate("/login", { replace: true });
        } else {
          if (error.response.data.data.challenge == "NEW_PASSWORD_REQUIRED") {
            navigate(
              "/create-account",
              { state: { email: email, temporaryPassword: password } },
              { replace: true }
            );
            setSessionId(error.response.data.data.session_id);
          }
        }
      } finally {
      }
    }
  };
  return showLoginPage && (
    <FullHeightRow>
      <Layout className="authLayout" style={{ backgroundColor: "#ffffff" }}>
        <Row span={24}>
          <Col span={12} className="colLayoutBlock">
            <AuthLeftContainer>
              <div className="flexBlock" style={{ justifyContent: "center" }}>
                <div className="vCenterBlock">
                  <div className="hCenterBox">
                    <AuthTitleBlock>
                      <div className="logo">
                        <img src={Logo} alt="HaberERP" />
                      </div>
                      <h1>See Kaiznn in action</h1>
                      <p>
                        See how integrated deckle mangement system can reduce
                        trim loss and improve order fulfilment
                      </p>
                    </AuthTitleBlock>
                    {errorMessage && (
                      <AlertContainer
                        color="red"
                        icon={alertRed}
                        msg={errorMessage}
                      />
                    )}
                    <HaberForm>
                      <Form
                        name="basic"
                        autoComplete="off"
                        className="haberLogin"
                        validateMessages={validateMessages}
                      >
                        <Form.Item
                          name="username"
                          value
                          rules={[{ required: true, type: "email" }]}
                          className="mailIcon"
                        >
                          <Input
                            placeholder="Enter your email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                          />
                        </Form.Item>

                        <Form.Item
                          name="password"
                          rules={[{ required: true }]}
                          className="lockIcon"
                        >
                          <Input.Password
                            placeholder="Enter your password"
                            value={password}
                            onChange={(event) =>
                              setPassword(event.target.value)
                            }
                          // Preventing password pasting
                          // onPaste={(e)=>{
                          //   e.preventDefault()
                          //   return false;
                          //   }}
                          />
                        </Form.Item>

                        <Form.Item
                          name="remember"
                          valuePropName=""
                          wrapperCol={{ span: 24 }}
                          className="alignedBox"
                        >
                          <Checkbox className="logCheck"
                            onChange={rememberMeHandler}
                            checked={isChecked}>
                            Remember me
                          </Checkbox>
                          <Link to="/reset-password">Forgot Password?</Link>
                        </Form.Item>

                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="btnSubmit"
                            onClick={onLoginClick}
                            disabled={
                              password == "" || email == "" ? true : false
                            }
                          >
                            Login
                          </Button>
                        </Form.Item>
                      </Form>
                      {/* <div className="pageLinks">
                        <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                        <Link to="/terms-and-conditions">
                          Terms & Conditions
                        </Link>
                      </div> */}
                    </HaberForm>
                  </div>
                </div>
              </div>
            </AuthLeftContainer>
          </Col>
          <Col span={12} className="colLayoutBlock">
            <AuthRightContainer />
          </Col>
        </Row>
      </Layout>
    </FullHeightRow>
  );
};

export default Login;
